import { Text, VStack, theme } from '@squire/ui';

import { Skeleton } from '@/components/_shared/Skeleton';
import { useScreenTranslations } from '@/hooks/useScreenTranslations';

const PaymentMethodSkeleton = () => {
  const { t } = useScreenTranslations('ConfirmBookingBottomSheet');

  return (
    <VStack space={theme.spacing[3]}>
      <Text variant="lStrong" color="textPrimary">
        {t('paymentMethod')}
      </Text>

      <Skeleton width="100%" height={46} />
      <Skeleton width="100%" height={46} />
    </VStack>
  );
};

PaymentMethodSkeleton.displayName = 'PaymentMethodSkeleton';
export { PaymentMethodSkeleton };
